/**
 * Examples:
 * - "2026-04-23T06:06:53" -> Date(UTC)
 * - "2026-04-23T06:06:53Z" -> Date(UTC)
 * - "2026-04-23T06:06:53+00:00" -> Date(UTC)
 *
 * @param {string} isoLike
 * @returns {Date | null}
 */
function utc(isoLike) {
  const raw = String(isoLike ?? "").trim()
  if (!raw) {
    return null
  }

  const hasTimezone = /([zZ]|[+\-]\d{2}:?\d{2})$/.test(raw)
  const normalized = hasTimezone ? raw : `${raw}Z`
  const date = new Date(normalized)
  return Number.isFinite(date.getTime()) ? date : null
}

/** @example parseDate.utc("2026-04-23T06:06:53") */
export const parseDate = { utc }
